module.exports = __webpack_public_path__ + "img/living-room.b8e6fe9d.svg";